import React from 'react';
import {NavLink} from 'react-router-dom'
import NewWindowLink from './NewWindowLink';
import wa from '../static/wa.png';
import yt from '../static/yt.png';
import donate from '../static/donate.svg';
import gplay from '../static/gplay.svg';
import appstore from '../static/appstore.svg';
import infographics from "../static/delhi-covid-infographics.png";
import {EXTERNAL_URLS} from "../constants";

const OtherLinks = ({showInfographics = true}) => {
    return (
        <div>
            <div className="asideComponent" style={{marginBottom: '28px'}}>
                {showInfographics && <div>
                    <h6 style={{border: 'none', padding: '14px 0'}}>Infographics</h6>
                     <a href = '/infographics/'><div
                        style={{
                            backgroundImage: `url(${infographics})`,
                            height: '150px',
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat'
                        }}
                    />
                    </a>
                    <NavLink to='/infographics/'>
                        <p style={{ fontSize: '1em', textDecoration: 'underline', marginTop: '1em'}}>
                            View All Infographics →
                        </p>
                    </NavLink>
                </div>}
                <h6 style={{
                    marginTop: '1.5em'
                }}>Other Links</h6>
                <NewWindowLink url={EXTERNAL_URLS.whatsapp}>
                    <div className="asideComponentItem" style={{color: '#878787'}}><img src={wa} style={{
                        marginRight: '8px',
                        height: '24px'
                    }}/>Delhi Govt. Corona Helpline 8800007722
                    </div>
                </NewWindowLink>
                <NewWindowLink
                    url={EXTERNAL_URLS.youtubeChannel}>
                    <div className="asideComponentItem" style={{color: '#878787'}}><img src={yt} style={{
                        marginRight: '8px',
                        height: '18px'
                    }}/>Delhi Government&quot;s Youtube Channel
                    </div>
                </NewWindowLink>
            </div>
            <NewWindowLink url={EXTERNAL_URLS.lgCMReliefFund}>
                <div className="footercta" style={{background: '#EC4B4B', color: 'white'}}><img src={donate} style={{
                    marginRight: '8px',
                    height: '20px',
                    fontWeight: 600
                }}/>Donate to CM/LG Relief Fund
                </div>
            </NewWindowLink>
            <div className="asideComponent">
                <h6 style={{borderBottom: 'none', paddingBottom: '5px'}}>Download Apps</h6>
                <div>
                  <a href="https://play.google.com/store/apps/details?id=com.delhi.covidcare">  <img src={gplay} style={{marginRight: '6px'}}/> </a>
                  <a href="https://apps.apple.com/in/app/delhi-corona/id1516485091"> <img src={appstore}/>  </a>  
                </div>
            </div>
        </div>
    )
};

export default OtherLinks;
